module.exports = "<div class=\"contact-suport-container\" *ngIf=\"popupService.popupList.popups['contact-support']\" (click)=\"closePopup()\">\n  <div class=\"contact-support-content contact-message\" (click)=\"baseService.stopProp($event)\">\n    <i class=\"material-icons\" (click)=\"closePopup()\">close</i>\n    <div class=\"message\">\n      To turn on demographics, call our sales department at +1-877-777-9037\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/contact-support/contact-support.component.html
// module id = ./src/app/components/popups/contact-support/contact-support.component.html
// module chunks = main